import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { CardLayout } from '@modules/card/enums/card-layout.enum';
import { Screen } from '@modules/shared/services/window.service';

import { CardComponent } from '../../card/card/card.component';
import { MediaComponent } from '../../media/media.component';
import { StaggeredSectionModel } from '../models/staggered-section.model';
import { SectionDefaultsComponent } from '../section-defaults';

@Component({
  selector: 'mb-staggered-section',
  templateUrl: './staggered-section.component.html',
  styleUrls: ['./staggered-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CardComponent, MediaComponent],
})
export class StaggeredSectionComponent extends SectionDefaultsComponent {
  public CardCollayout = CardLayout.COLUMN;
  public mediumLayouts = {
    [Screen.XXS]: CardLayout.COLUMN,
    [Screen.XS]: CardLayout.ROW,
  };
  @Input() data!: StaggeredSectionModel;
}
